// Versione attiva dell'NDA. Quando il testo cambia, creare un nuovo documento
// ndaVersioni/{nuovaVersione} su Firestore e alzare questa costante: chi ha
// firmato una versione precedente verrà rigatato automaticamente al gate.
export const NDA_ACTIVE_VERSION = "1.0";
